import mod from "-!./bio.js?vue&type=script&lang=js&"; export default mod; export * from "-!./bio.js?vue&type=script&lang=js&"